import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);

    const previousTitle = document.title;
    document.title = "404 — Page Not Found | Dumbverse";

    const setMeta = (selector: string, attr: string, value: string) => {
      const el = document.head.querySelector(selector) as HTMLMetaElement | HTMLLinkElement | null;
      if (!el) return null;
      const prev = el.getAttribute(attr);
      el.setAttribute(attr, value);
      return { el, attr, prev };
    };

    const canonicalHref = `https://dumbverse.app${location.pathname}`;
    const description = "This page doesn't exist in the Dumbverse. Return to the homepage to join the waitlist.";

    const changes = [
      setMeta('meta[name="description"]', "content", description),
      setMeta('link[rel="canonical"]', "href", canonicalHref),
      setMeta('meta[property="og:title"]', "content", "404 — Page Not Found | Dumbverse"),
      setMeta('meta[property="og:description"]', "content", description),
      setMeta('meta[property="og:url"]', "content", canonicalHref),
      setMeta('meta[name="twitter:title"]', "content", "404 — Page Not Found | Dumbverse"),
      setMeta('meta[name="twitter:description"]', "content", description),
    ];

    // Add robots noindex for 404
    let robots = document.head.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    let robotsCreated = false;
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
      robotsCreated = true;
    }
    const prevRobots = robots.getAttribute("content");
    robots.setAttribute("content", "noindex, follow");

    return () => {
      document.title = previousTitle;
      changes.forEach((c) => {
        if (c && c.prev !== null) c.el.setAttribute(c.attr, c.prev);
      });
      if (robotsCreated) {
        robots?.remove();
      } else if (prevRobots !== null && robots) {
        robots.setAttribute("content", prevRobots);
      }
    };
  }, [location.pathname]);

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-background px-6">
      <div className="relative z-10 text-center">
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-muted-foreground">Lost in the void</p>
        <h1 className="mt-4 font-bebas text-7xl md:text-9xl leading-none text-foreground">404</h1>
        <p className="mt-2 font-playfair italic text-xl text-muted-foreground">
          This page doesn't exist in the Dumbverse.
        </p>
        <a
          href="/"
          className="mt-8 inline-block h-12 rounded bg-primary px-8 font-bebas text-lg leading-[3rem] tracking-wide text-primary-foreground hover:bg-primary/90 transition-colors"
        >
          Return home
        </a>
      </div>
    </div>
  );

};

export default NotFound;
